import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import GLOBAL from '../public/lib/config.js';
import '../public/lib/element-variables.scss';
import vueCookies from 'vue-cookies';

import publicFun from './publicFun.js'

Vue.use(ElementUI);
Vue.use(vueCookies);
Vue.config.productionTip = false
Vue.prototype.GLOBAL = GLOBAL
Vue.prototype.publicFun = publicFun


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


